import { Section } from "../../../../components";
import { useGetOrganizationArchivedLeads } from "../../../../services/organtization/lead/get-archived-leads";
import { useGetOrganization } from "../../../../services";
import { ExistingLeadRow } from "./ExistingLeadRow";

interface Props {
  organizationId: string;
}

export const ArchivedLeads = ({ organizationId }: Props) => {
  const { data } = useGetOrganizationArchivedLeads(organizationId);
  const { data: orgData } = useGetOrganization(organizationId);

  return (
    <Section title="Archived Leads" className="bg-gray-3">
      {data.map((lead) => (
        <ExistingLeadRow
          key={lead.id}
          organizationId={organizationId}
          profiles={orgData.profiles}
          lead={lead}
        />
      ))}
    </Section>
  );
};
